import Link from 'next/link';
import { useEffect, useRef, useState } from 'react';
import Slider from 'react-slick';
import AOS from 'aos';
import MetaSeo from '../MetaSeo';
import { Form, message } from 'antd';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import { getDetailServices } from '../../redux/actions/services';
import useTrans from '../../hooks/useTrans';


export default function Service(props) {
    const dispatch = useDispatch();
    const trans = useTrans();
    const fillColor = [
        "#EB2725", "#FDE002", "#0EC1E9", "#0063AA", "#1A2DD8", "#000959", "#2AD3B5", "#8A0ED6", "#1999F4"
    ];


    useEffect(() => {
        // if (props.match.params.id) {
        //     getDetail(props.match.params.id);
        // }

    }, [dispatch]);
    const settings = {
        // className: "slider variable-width",
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 4,
        prevArrow: <button class='slick-prev slick-arrow' aria-label='Next' type='button'><img src='../assets/images/home/icon-next.svg' /></button>,
        nextArrow: <button class='slick-next slick-arrow' aria-label='Next' type='button'><img src='../assets/images/home/icon-next.svg' /></button>,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                }
            }
        ],
    };
    const dataSeo = {
        url: `${process.env.NEXT_PUBLIC_SEO_URL}/service/${props.seo_url}`,
        type: 'website',
        title: `${props.title} | TCOM`,
        description: props.seo_description || 'TCOM',
        image: props.background_image,
        domain: process.env.NEXT_PUBLIC_DOMAIN,
        card: 'summary_large_image'
    };
    return (
        <>
            <MetaSeo {...dataSeo} />
            <div id='web-development' className={props.title}>
                <div className='main-content'>
                    <div className='r-big-banner'>
                        <div>
                            <image src={props.background_image} />
                        </div>
                        <div className='container'>
                            <div className='row'>
                                <div className='col-12 col-md-6'>
                                    <div className='customCloumnLeft'>
                                        <h1>{props.title}</h1>
                                        <p className='desc'>{props.description}</p>
                                        {/* img mobile */}
                                        <div className='imgBgMB'>
                                            <img alt='' src={props.image_detail} />
                                        </div>
                                        {/* end img mobile */}
                                        <div className={props.description_sub && props.description_sub.length > 4 ? 'feature' : 'customColumn'}>
                                            {props.description_sub.map(item => {
                                                return (
                                                    <div className='box'>
                                                        <div className='icon'>
                                                            <img style={{ width: 36, height: 36 }} src={item.image} alt='' />
                                                        </div>
                                                        <p>{item.text}</p>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                </div>
                                <div
                                    // className="col-12 col-md-6 customImgMb"
                                    className={props.description_sub && props.description_sub.length === 0 ? 'col-12 col-md-12 customImgMb' : 'col-12 col-md-6 customImgMb'}>
                                    <img alt='' src={props.image_detail} />
                                </div>
                            </div>
                        </div>
                    </div>
                    {props.strengths.length ? <div className='r-strengths'>
                        <div className='container'>
                            <div className='row'>
                                <div className='col-12 col-md-3 col-left'>
                                    <h3 className='title'>{trans.service.strength_sub1}</h3>
                                </div>
                                <div className='col-12 col-md-9 col-right'>
                                    <div className='row'>
                                        {props.strengths.map(item => {
                                            return (
                                                <div className='col-12 col-md-6'>
                                                    <div className='box'>
                                                        <pre><p style={{whiteSpace: 'break-spaces'}}>{item.text}</p></pre>
                                                    </div>
                                                </div>
                                            );
                                        })}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> : ''}
                    {/* Mobile App development serveice */}
                    {props.language_code.length ? <div className='r-technology'>
                        <div className='container-fluid'>
                            <h3 className='title'>{trans.service.language_code} &amp; {trans.service.tech}</h3>
                            <ul>
                                {props.language_code.map(item => {
                                    return (
                                        <li>
                                            <div className='icon'>
                                                <img src={item.image} alt='' />
                                            </div>
                                            <div className='name'>{item.text}</div>
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                    </div> : ''}

                    {props.tool.length ? <div className='r-technology'>
                        <div className='container-fluid'>
                            <h3 className='title'>{'CÔNG CỤ'}</h3>
                            <ul>
                                {props.tool.map(item => {
                                    return (
                                        <li>
                                            <div className='icon'>
                                                <img src={item.image} alt='' />
                                            </div>
                                            <div className='name'>{item.text}</div>
                                        </li>
                                    );
                                })}

                            </ul>
                        </div>
                    </div> : ''}
                    {/* step */}
                    {/* <div id='offshore'>
                        {props.step_action.length ? <div className='r-step'>
                            <div className='container'>
                                <div className='title-center'>
                                    <h3>{trans.service.step_active}</h3>
                                    <p className='desc'>{trans.service.step_active_description}</p>
                                </div>
                                <Slider {...settings}>
                                    {props.step_action.map((item, index) => {
                                        return (
                                            <div key={index} className='item'>
                                                <div className='top'>
                                                    <div className='number'>{index + 1}</div>
                                                    <div className='text'>step</div>
                                                </div>
                                                <h3>{item.name}</h3>
                                                <p>{item.detail}</p>
                                            </div>
                                        );
                                    })
                                    }
                                </Slider>
                            </div>
                        </div>
                            : ""}
                    </div> */}
                    <div className={props.field.length === 0 ? "r-process custom-mb-r-process" : "r-process"}>
                        <div className='container'>
                            <div className='row'>
                                <div className='col-md-12 col-lg-5'>
                                    <div className='col-left'>
                                        <div className='subtract-2'>
                                            <img src='/assets/images/offshore/Subtract-2.png' alt='' />
                                        </div>
                                        <h3>{trans.home.step_active}</h3>
                                        <p>{trans.home.step_active_description}</p>
                                        <div className='subtract customWidthSubtract'>
                                            <img className='w-100' src='/assets/images/service/img2.webp' alt='' />
                                        </div>
                                    </div>
                                </div>
                                <div className=' col-md-12 col-lg-7'>
                                    <div className='col-right'>
                                        <ul>
                                            {props.step_action.length ? props.step_action.map((item, index) => {
                                                return (
                                                    <li>
                                                        <div className='icon'>
                                                            <img style={{ width: 65, height: 65 }} src={item.image} alt='' />
                                                        </div>
                                                        <div className='content'>
                                                            <p>{`0${index + 1}`}</p>
                                                            <div className='text text-white'>
                                                                <strong>{item.name}</strong> <br />
                                                                <span>{item.detail}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </li>
                                                );
                                            }) : ''
                                            }

                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* end step */}
                    {/* fields */}
                    {props.field.length ? <div className='r-fields'>
                        <div className='container'>
                            <div className='row'>
                                <div className='col-12 col-md-4 col-left'>
                                    <div className='title-left'>
                                        <h3>{trans.service.field}</h3>
                                        <p className='desc'>{trans.service.field_description}</p>
                                        <img src='/assets/images/home/fields-img-1.png' alt='' />
                                    </div>
                                </div>
                                <div className='col-12 col-md-8 col-right'>
                                    <div className='row'>
                                        {props.field.map((item, index) => {
                                            return (
                                                <div className='col-6 col-md-4'>
                                                    <div className='field-item'>
                                                        <div className='icon'>
                                                            <img style={{ width: 57 }} src={item.image} alt='' />
                                                        </div>
                                                        <h3>{item.text}</h3>
                                                        <svg width={114} height={3} viewBox='0 0 114 3' fill='none' xmlns='http://www.w3.org/2000/svg'>
                                                            <rect x='0.441406' y='0.140137' width='113.543' height='2.31721' fill={fillColor[index]} />
                                                        </svg>
                                                    </div>
                                                </div>
                                            );
                                        })}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> : ""}
                    {/* end fields */}
                </div>
            </div >
        </>
    );
}
